import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { find as findPurchase } from 'billing/purchases/actions';
import { purchase } from 'app/routes';

export function* purchaseNavigate({ purchaseId }) {
  yield put(authenticate(purchase(purchaseId)));
  yield put(findPurchase(purchaseId));
}
